import { Subject, shareReplay, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { fromFetch } from "rxjs/fetch";
import { LanguageService } from "./services/language-service.js";
import $ from "jquery";

/**
 *
 * @param {String} udstillerId
 * @param {LanguageService} localizationService
 */
export function InitializeBookingForm(udstillerId, localizationService) {
  const locale = localizationService.getLanguage().toLowerCase();
  const getTimeslotsUrl = `/wp-json/ug/v1/exhibitor/${udstillerId}/timeslots/available`;
  const daySelectorElements = document.querySelectorAll(
    'select[name^="et_pb_contact_dag_"]'
  );
  const timeSelectorElements = document.querySelectorAll(
    'select[name^="et_pb_contact_tidspunkt_"]'
  );

  const setElementValue = (value) => (element) => (element.value = value);
  document
    .querySelectorAll('[id^="et_pb_contact_udstillerid_"]')
    .forEach(setElementValue(udstillerId));
  document
    .querySelectorAll('[id^="et_pb_contact_udstillersprog_"]')
    .forEach(setElementValue(locale));

  const timeslots$ = getJson$(getTimeslotsUrl);
  const translations = localizationService.getTranslations();
  const DaySelectorChangeEvents$ = new Subject();

  const prependEmptyOption = (listOfOptions) => {
    const placeholder = ["<option></option>"];
    listOfOptions[0] = placeholder.concat(listOfOptions[0]);
    return listOfOptions;
  };

  const dayOptions$ = timeslots$.pipe(
    map((daysWithTimeslots) => {
      const daysOptions = daysWithTimeslots.map((day) =>
        DayToOption(day.day, locale)
      );
      const daysChoices = daysWithTimeslots.map((day) => {
        return {
          value: day.day,
          label: DayToChoices(day.day, locale),
        };
      });
      return [daysOptions, daysChoices];
    }),
    map(prependEmptyOption)
  );

  const timeslotOptions$ = combineLatest(
    timeslots$,
    DaySelectorChangeEvents$
  ).pipe(
    map(([timeslots, changeEvent]) => {
      const date = changeEvent.target.value;
      const dayWithTimeslots = timeslots.filter(
        (dayWithTimeslots) => dayWithTimeslots.day === date
      );
      if (dayWithTimeslots.length > 0) {
        const timeslots = dayWithTimeslots[0].timeslots;
        if (timeslots.length > 0) {
          const timeslotsOptions = timeslots.map((timeslot) =>
            TimeslotToOption(timeslot, locale)
          );
          const timeSlotsChoices = timeslots.map((timeslot) => {
            return {
              value: TimeslotToChoicesValue(timeslot),
              label: TimeslotToChoicesLabel(timeslot, locale),
            };
          });
          return [timeslotsOptions, timeSlotsChoices];
        } else {
          return [
            [
              "<option>" +
                translations.bookMeetings.placeholderNoAvailibleTimes +
                "</option>",
            ],
            {
              value: "",
              label: translations.bookMeetings.placeholderNoAvailibleTimes,
            },
          ];
        }
      } else {
        return [];
      }
    }),
    map(prependEmptyOption)
  );

  $(daySelectorElements).on("change", (e) => {
    DaySelectorChangeEvents$.next(e);
  });

  dayOptions$.subscribe((optionHtmlList) =>
    daySelectorElements.forEach((element) => {
      //element.innerHTML = optionHtmlList[0].join("");
      const existingInstance = element.choices;
      existingInstance.setChoices(optionHtmlList[1], "value", "label", true);
    })
  );
  timeslotOptions$.subscribe((timeSlotOptions) =>
    timeSelectorElements.forEach((element) => {
      //element.innerHTML = timeSlotOptions[0].join("");
      const existingInstance = element.choices;
      existingInstance.setChoices(timeSlotOptions[1], "value", "label", true);
    })
  );
}

function getJson$(url) {
  return fromFetch(url).pipe(
    switchMap((response) => {
      if (!response.ok) {
        throw `There was an error with status ${response.status}`;
      } else {
        return response.json();
      }
    }),
    shareReplay(1)
  );
}

function uppercaseFirstCharacter(str) {
  if (str.length === 0) {
    return str; // Return empty string if input is empty
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function DayToOption(day, locale) {
  const date = new Date(day);
  // Specify date and time format using "style" options (i.e. full, long, medium, short)
  let dateString = new Intl.DateTimeFormat(locale, {
    dateStyle: "full",
  }).format(date);

  return MakeOption(day, uppercaseFirstCharacter(dateString));
}

function DayToChoices(day, locale) {
  const date = new Date(day);
  // Specify date and time format using "style" options (i.e. full, long, medium, short)
  let dateString = new Intl.DateTimeFormat(locale, {
    dateStyle: "full",
  }).format(date);

  return uppercaseFirstCharacter(dateString);
}

function TimeslotToOption(timeslot, locale) {
  const dateTimeString = `${timeslot.date}T${timeslot.start_time}`;
  const date = new Date(`${timeslot.date}T${timeslot.start_time}`);
  // Specify date and time format using "style" options (i.e. full, long, medium, short)
  let timeString = new Intl.DateTimeFormat(locale, {
    hour: "numeric",
    minute: "numeric",
  }).format(date);

  return MakeOption(dateTimeString, timeString);
}

function TimeslotToChoicesValue(timeslot) {
  const dateTimeString = `${timeslot.date}T${timeslot.start_time}`;
  return dateTimeString;
}
function TimeslotToChoicesLabel(timeslot, locale) {
  const date = new Date(`${timeslot.date}T${timeslot.start_time}`);
  // Specify date and time format using "style" options (i.e. full, long, medium, short)
  let timeString = new Intl.DateTimeFormat(locale, {
    hour: "numeric",
    minute: "numeric",
  }).format(date);

  return timeString;
}

function MakeOption(value, text) {
  return `<option value="${value}">${text}</option>`;
}
function MakePlaceholderOption(text) {
  return `<option disabled selected>${text}</option>`;
}
